import { render, staticRenderFns } from "./insights-video-page.vue?vue&type=template&id=ff3f4d4c&"
var script = {}
import style0 from "../../assets/styles/pages/_Insights.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../../assets/styles/pages/_ArticleDetail.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports